import "./Navbar.css";
function Navbar() {
  return (
    <div>
      <nav>
        <h1 className="heading">Top Courses</h1>
      </nav>
    </div>
  );
}

export default Navbar;
